import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
import CedarLogo from '../components/CedarLogo';
import AnimatedButton from '../components/AnimatedButton';

export default function WelcomeScreen() {
  const { setUsername } = useAppContext();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Pick a name to get rolling');
      return;
    }
    if (trimmed.length > 30) {
      setError('Name too long (max 30 chars)');
      return;
    }
    setUsername(trimmed);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-cannabis-900 to-cannabis-800 flex items-center justify-center px-4">
      <motion.div
        className="w-full max-w-sm"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <CedarLogo size={80} />
        </div>

        {/* Tagline */}
        <h1 className="text-4xl font-black text-center text-cream mb-2">
          Hashups
        </h1>
        <p className="text-center text-cream/60 mb-8 text-lg">
          Rate joints. Share vibes. Find strains.
        </p>

        {/* Input */}
        <div className="space-y-4 mb-6">
          <input
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setError('');
            }}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            placeholder="Pick your name..."
            maxLength={30}
            autoFocus
            className="w-full bg-cannabis-800 border border-cannabis-600 rounded-lg px-4 py-3 text-cream placeholder:text-cream/30 focus:outline-none focus:border-cannabis-400 transition"
          />
          {error && <p className="text-red-400 text-sm">{error}</p>}
        </div>

        {/* Button */}
        <AnimatedButton
          onClick={handleSubmit}
          disabled={!name.trim()}
          size="lg"
          className="w-full mb-4"
        >
          Let's Go
        </AnimatedButton>

        {/* Skip link */}
        <button
          onClick={() => navigate('/')}
          className="w-full text-center text-cream/50 hover:text-cream/70 transition text-sm py-2"
        >
          Browse first
        </button>
      </motion.div>
    </div>
  );
}
